import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, Injector, HostListener, Renderer2 } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { TransferState, makeStateKey } from '@angular/core';
import { environment } from '../environments/environment';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// import 'rxjs/add/operator/filter';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/mergeMap';
import { take, filter, map, mergeMap } from 'rxjs/operators';

// services
import { DataStorageService } from '../app/shared/services/data-storage.service';
import { AppStateService } from '../app/shared/services/app-state.service';
import { CopyService } from '../app/shared/services/app-copy.service';
import { UtilityService } from '../app/shared/services/utility.service';
import { UrlParamsService } from '../app/shared/services/url-params.service';
import { UserAgentService } from '../app/shared/services/user-agent.service';
import { LoginService } from '../app/shared/services/login.service';
import { ErrorHandler } from '../app/shared/services/error-handler.service';
import { SessionService } from '../app/shared/services/session.service';
import { ApplicationInsightsService } from '../app/shared/services/app-insights.service';
import { AirportCopyService } from '../app/shared/services/app-airport-copy.service';
import { RulesCopyService } from './shared/services/app-rules-copy.service';
// models
import { CopyRequestItem } from '../app/shared/models/copy-request.interface';
import { AppState } from '../app/booking/models/app-state.interface';
// globals
import { ABC_PARTNERS, CRM_POPUP_CONTENT, GET_STATIC_COPY_DATA, SLOT_NUMBER, SLOT_VERSION } from '../app/shared/globals';
import * as express from 'express';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { HttpClient } from '@angular/common/http';

declare var System: any;

// Assuming you have your package.json file in the assets folder
import packageJson from '../../package.json';

const PARTNER_KEY = makeStateKey('partner_key');
const PARTNER_SERVER_KEY = makeStateKey('partner_server_key');
const SESSION_EMAIL = makeStateKey('session_email_key');
const SESSION_ID = makeStateKey('session_id_key');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AppStateService, UrlParamsService, SessionService, LoginService, ApplicationInsightsService]
})
export class AppComponent implements OnInit, OnDestroy {

  private _routeParamsSubscription: Subscription;
  private _partnerLoadedSubscription: Subscription;
  private _verifyEmailSubscription: Subscription;
  private _userSubscription: Subscription;
  private _sessionDataSubscription: Subscription;
  private _csMotoSubscription: Subscription;
  private _copyInitSubscription: Subscription;
  private _resizeTimer;
  private _sessionData = null;
  private _bookingReducerSubscription?: Subscription;

  public copyLoaded: Boolean = false;
  public currentPartner = null;
  public appVersion;
  public partnerLoaded = false;
  public isUIVersionSet = false;
  public hasPartner;
  public env = environment;
  public showLoginOverlay = false;
  public userName = '';
  public userHasPassword = null;
  public userHasPhoneNumber = null;
  public sessionEmail = null;
  public sessionID = null;
  public crmPopupContent;
  public isMotoPayment = false;
  public loadAPI: Promise<any>;
  public isPaymentScreen: boolean = false;
  private history: string[] = [];

  private strapiAirlineCode = 'OTHER';

  public slotNumber = SLOT_NUMBER;
  public slotVersion = SLOT_VERSION;

  constructor(
    private _titleService: Title,
    private _appStore: Store<AppState>,
    private _router: Router,
    private _http: HttpClient,
    private _activatedRoute: ActivatedRoute,
    private _dataStorageService: DataStorageService,
    private _copyService: CopyService,
    private _appStateService: AppStateService,
    private _utilityService: UtilityService,
    private _userAgentService: UserAgentService,
    private _loginService: LoginService,
    private _errorService: ErrorHandler,
    private _injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) document,
    private _serverState: TransferState,
    private _urlParamsService: UrlParamsService,
    private _renderer: Renderer2,
    private _sessionService: SessionService,
    private _insightsService: ApplicationInsightsService,
    private _airportCopyService: AirportCopyService,
    private _rulesCopyService: RulesCopyService
  ) {

    if (isPlatformServer(this.platformId)) {

      // get query params from the server req
      const req = this._injector.get(REQUEST);
      const urlSection = req.url.split('/')[1];
      const uiVersion = this.getPageUI(urlSection);

      _renderer.setAttribute(document.body, 'id', uiVersion);
      this.isUIVersionSet = true;

      this._sessionService.checkQuerySession();

      this._sessionDataSubscription = this._sessionService.sessionDataReturned$
        .subscribe(hasData => {
          if (hasData) {
            // for serve strapi load translations
            this._copyService.getCopy(this._sessionData.airline);
            this._rulesCopyService.getStrapiCopy(this._sessionData.airline);

            const qs = this._sessionService.getQuerySessionData();
            this._sessionData = this._urlParamsService.parseReturnedData(qs.data.responseString);
            this._serverState.set(SESSION_EMAIL, this._sessionData.emailAddress as any);
            this._serverState.set(SESSION_ID, qs.data.sessionID as any);
            if (this._sessionDataSubscription) { this._sessionDataSubscription.unsubscribe(); }
          } else {
            // load on server for normal flow (OTHER)
            this._copyService.getCopy();
          }
        });

      let queryPartner = null;
      if (typeof req.query.partner !== 'undefined') {
        // uncomment if using partner from dotcom
        // queryPartner = req.query.partner;
        queryPartner = 'NONE';
      }
      this._dataStorageService.getSavedDataPromise().then((res: any) => {
        if (res) {
          let airlineCode = res.flightFinderReducer.quoteFlightRequest.airline;
          if (!airlineCode) {
            airlineCode = res.bookingReducer.bookingDetails.carrier.airlineCode;
          }
          console.log('SERVER: airlineCode', res.flightFinderReducer.quoteFlightRequest.airline, res.bookingReducer.bookingDetails.carrier.airlineCode);
          this._copyService.getCopy(airlineCode);
        }
      })
        .catch(err => {
          this._copyService.getCopy();
          console.log('SERVER: error', err);
        });
      this._serverState.set(PARTNER_SERVER_KEY, queryPartner as any);
      this.setPartnerView(queryPartner);
    } else {
      this._airportCopyService.getStaticCopy();

      this.partnerLoaded = false;

      // set slot number for booking pod to use
      localStorage.setItem('slotNumber', SLOT_NUMBER);
      localStorage.setItem('slotVersion', SLOT_VERSION);
      // localStorage.getItem('slotNumber')

      // set page title on route change
      _router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .pipe(map(() => _activatedRoute))
        .pipe(map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          };
          return route;
        }))
        .pipe(filter((route) => route.outlet === 'primary'))
        .pipe(mergeMap((route) => route.data))
        .subscribe((event) => {
          this._titleService.setTitle(event['title']);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        });

      // Temporary fix for my account/login/register styling
      // subscribe to router change to update UI version
      this.setUIVersion();
      this.isUIVersionSet = true;

      this.sessionEmail = this._serverState.get(SESSION_EMAIL, null as any);
      this.sessionID = this._serverState.get(SESSION_ID, null as any);

      // get app version, pass into store (used for AB testing data)
        this.appVersion = packageJson.version;
        const abData = { bookingFormEnv: this.env.abEnv, bookingFormVersion: this.appVersion };
        this._appStore.dispatch({ type: 'UPDATE_AB_TEST_FORM', payload: abData });

      // get and refresh store if cookie exists
      if (this._dataStorageService.getCookieDataID() !== null) {
        this._dataStorageService.getSavedDataPromise().then((store: AppState) => {
          this._copyService.getCopy(this.getState(this._appStore).bookingReducer.bookingDetails?.carrier?.airlineCode || 'OTHER');
          // if cookie is invalid
          // set to default
          if (store === null) {
            this.setPartnerView();
            this.setDataSubscriptions();
            this._dataStorageService.removeCookie('DataID');
            return;
          }

          const partnerFromServer = this._serverState.get(PARTNER_SERVER_KEY, null as any);
          if (partnerFromServer !== null) {
            this.setPartnerView();
          } else {
            this._appStateService.refreshPartner(store);
            this._appStore.dispatch({ type: 'PARTNER_LOADED', payload: true });
          }
          this.setDataSubscriptions();
        });
      } else {
        this.setPartnerView();
        this.setDataSubscriptions();
      }

      this._userAgentService.storeUserAgentData();

      let langParam = localStorage.getItem('languageCode') ? localStorage.getItem('languageCode') : window.navigator.language.split('-')[0];
      let langCode;
      let userPreferredLanguage;
      switch (langParam) {
        case 'en':
          langCode = langParam
          userPreferredLanguage = '';
          break;
        case 'fr':
        case 'de':
        case 'it':
          langCode = langParam;
          userPreferredLanguage = `_${langParam}`;
          break;
        default:
          langCode = 'en';
          userPreferredLanguage = '';
      }

      this._appStore.dispatch({ type: 'UPDATE_LANGUAGE', payload: { 'language': userPreferredLanguage, 'languageCode': langCode } })

      this._copyInitSubscription = this._appStore
        .select("loadedStatusReducer")
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
        });

    }

    this.getCopyFromService();

    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isPaymentScreen = event.url === '/abc/payment' || event.url === '/ccd/payment';
      }
    })
  }

  getCopyFromService() {
    this._copyService.getCopy();
  }

  ngOnInit() {
    this._utilityService.cs();
    if (isPlatformBrowser(this.platformId)) {
      this.checkDeviceOrientation(window);

      this.crmPopupContent = btoa(JSON.stringify(CRM_POPUP_CONTENT));
      this._csMotoSubscription = this._appStore.select('flightFinderReducer')
        .subscribe(res => {
          this.isMotoPayment = res.csMotoFromUrl;
        })

      const state = this.getState(this._appStore).bookingReducer;
      const airlineCode = state?.bookingDetails?.carrier?.airlineCode || "OTHER";

      if (airlineCode.toLowerCase() !== "other") {
        console.log('get rules 1 call from app');
        this._rulesCopyService.getStrapiCopy(airlineCode);
      }

      // update strapi sieline code for translation not available
      if (airlineCode && airlineCode !== this.strapiAirlineCode) {
        this.strapiAirlineCode = airlineCode;
      }

    }

    this._bookingReducerSubscription = this._appStore
      .select('bookingReducer')
      .subscribe((res) => {
        const airlineCode =
          res?.bookingDetails?.carrier?.airlineCode || 'OTHER';
        if (airlineCode && airlineCode !== this.strapiAirlineCode) {
          this.strapiAirlineCode = airlineCode;

          console.log('get copy call from subscription in app');
          this._copyService.getCopy(airlineCode);

          if (airlineCode.toLowerCase() !== "other") {
            console.log('get rules copy call from subscription in app');
            this._rulesCopyService.getStrapiCopy(airlineCode);
          }
        }
      });

  }

  public setDataSubscriptions() {
    // get current stored partner
    this.currentPartner = this.getState(this._appStore).partnerReducer?.partnerName;
    this.partnerLoaded = true;

    const cookieUserToken = this._dataStorageService.checkCookie('DataT');
    // if session has user email from dotcom and user not logged in (no cookie saved), show login overlay
    if (this.sessionEmail !== null && this.sessionEmail !== '' && cookieUserToken === null) {
      this._loginService.validateEmail(this.sessionEmail);
      this._dataStorageService.setCookie('PortrE', btoa(this.sessionEmail));

      this._verifyEmailSubscription = this._loginService.validateUserSubject$
        .subscribe(res => {

          this._appStore.dispatch({ type: 'UPDATE_USER_STATUS', payload: res.verifyCustomerStatus });

          // if email matches an account, show login panel
          if (res.userLoginStatus === 1 || res.userLoginStatus === 2) {

            this.userName = res.firstName;
            this.userHasPassword = res.userLoginStatus === 1;
            this.userHasPhoneNumber = res.hasMobileNumber;
            this.showLoginOverlay = true;
            this._appStore.dispatch({ type: 'UPDATE_USER_SHOW_TOAST', payload: true });
          }
          if (this._verifyEmailSubscription) { this._verifyEmailSubscription.unsubscribe(); }

        });
    }

    // show welcome toast on login
    this._userSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        const userLoggedIn = user.userDetails.userLoggedIn;
        const userShowToast = user.userDetails.userShowToast;

        if (userLoggedIn && userShowToast) {
          const messageData = {
            icon: '',
            sticky: false,
            type: 'tooltip',
            title: 'Welcome back %s!',
            text: 'Thanks for logging in, we have now loaded your account details.'
          };

          this._errorService.handleCustomInfo(messageData, true, user.userDetails.currentUser.firstName);
          this._appStore.dispatch({ type: 'UPDATE_USER_SHOW_TOAST', payload: false });
        }
      });
  }

  private setPartnerView(urlAirline?) {

    const partnerFromServer = this._serverState.get(PARTNER_KEY, null as any);

    // if on refresh url doesn't have partner - server passes null through as urlAirline
    // set the partnerKey to null
    // also set the currentPartner and parterLoaded flag as may need to read params on flight-finder
    // i.e. view needs to render correctly on server
    if (urlAirline === null) {
      this.currentPartner = 'NONE';
      this._serverState.set(PARTNER_KEY, null as any);
      this.partnerLoaded = true;
      return;
    }

    if (urlAirline) {

      if ((this.currentPartner === null) || ((urlAirline !== null) && (urlAirline !== this.currentPartner))) {
        if (urlAirline !== null && urlAirline.length > 0) {
          // if query string is not null or empty
          this.setSessionPartnerQueryString(urlAirline);
        }
      }

    } else if (partnerFromServer === 'NONE' || partnerFromServer === null) {
      this._appStore.dispatch({ type: 'UPDATE_PARTNER_NAME', payload: { partnerName: 'NONE' } });
      this._appStore.dispatch({ type: 'PARTNER_LOADED', payload: true });
      this.currentPartner = partnerFromServer;
      // this.partnerLoaded = true;
    } else {
      this._appStore.dispatch({ type: 'UPDATE_PARTNER_NAME', payload: { partnerName: partnerFromServer } });
      this._appStore.dispatch({ type: 'PARTNER_LOADED', payload: true });
      this.currentPartner = partnerFromServer;
      // this.partnerLoaded = true;
    }

  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  setSessionPartnerQueryString(p) {

    if (typeof p !== 'undefined') {

      let queryPartner = p.toLocaleUpperCase();
      if (queryPartner.length < 2) { return; }

      // if partner sent through as airline code, get full name
      if (queryPartner.length === 2 || queryPartner.length === 3) {
        const foundPartner = ABC_PARTNERS.find(partner => partner.code === queryPartner);
        queryPartner = foundPartner ? foundPartner.codeName : 'NONE';
      }

      // test query parter against ABC partners
      if (ABC_PARTNERS.find(partner => partner.codeName === queryPartner)) {
        this._serverState.set(PARTNER_KEY, queryPartner as any);
      } else {
        this._serverState.set(PARTNER_KEY, 'NONE' as any);
      }

      this.currentPartner = queryPartner;
      this.partnerLoaded = true;
    }

  }

  ngOnDestroy() {
    if (this._copyInitSubscription) { this._copyInitSubscription.unsubscribe(); }
    if (this._partnerLoadedSubscription) { this._partnerLoadedSubscription.unsubscribe(); }
    if (this._routeParamsSubscription) { this._routeParamsSubscription.unsubscribe(); }
    if (this._csMotoSubscription) { this._csMotoSubscription.unsubscribe(); }
    if (this._bookingReducerSubscription) { this._bookingReducerSubscription.unsubscribe(); }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkDeviceOrientation(event.target);
  }

  setUIVersion() {
    this._router.events
      .subscribe(event => {

        if (!this.isUIVersionSet) { return; }

        const urlSection = this._router.url.split('/')[1].split('?')[0];
        const uiVersion = this.getPageUI(urlSection);

        this._renderer.setAttribute(document.body, 'id', uiVersion);
      });
  }

  getPageUI(urlSection) {
    if (urlSection === 'flight-finder' || urlSection === 'abc' || urlSection === 'ccd' || urlSection === 'complete' || urlSection === 'fly-back-details') {
      return 'new-ui';
    } else {
      return 'old-ui';
    }
  }

  checkDeviceOrientation(device) {
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(function () {
      const resizeWidth = device.screen.width;
      const resizeHeight = device.screen.height;
      const orientation = device.orientation ? device.orientation : null;

      const isMobileLandscape = (resizeWidth <= 740 && resizeHeight <= 414) && (orientation === 90 || orientation === -90);
      const isIphoneLandscape = (resizeHeight <= 740 && resizeWidth <= 414) && (orientation === 90 || orientation === -90);
      const isIphoneXLandscape = (resizeHeight === 812 && resizeWidth === 375) && (orientation === 90 || orientation === -90);

      if (isMobileLandscape || isIphoneLandscape || isIphoneXLandscape) {
        document.body.classList.add('mobile-landscape');
      } else {
        document.body.classList.remove('mobile-landscape');
      }
    }, 500);
  }

  closeOverlay(e: Event) {
    this.showLoginOverlay = false;
  }



}
